import React, { useState } from 'react';
import { Card, Row, Col, Accordion, Form, Button } from 'react-bootstrap';
import './FAQ.css';

const FAQ = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeKey, setActiveKey] = useState('0');

  const faqData = [
    {
      id: '0',
      category: 'Compte et Inscription',
      icon: 'fa-user-circle',
      questions: [
        {
          question: 'Comment créer un compte sur SenOffre ?',
          answer: 'Pour créer un compte, cliquez sur le bouton "S\'inscrire" en haut de la page d\'accueil. Remplissez le formulaire avec vos informations personnelles et professionnelles, puis validez votre email pour activer votre compte. Vous pouvez choisir entre un compte candidat ou un compte entreprise selon vos besoins.'
        },
        {
          question: 'J\'ai oublié mon mot de passe, que faire ?',
          answer: 'Cliquez sur "Mot de passe oublié" sur la page de connexion. Entrez votre adresse email et vous recevrez un lien pour réinitialiser votre mot de passe. Le lien est valide pendant 24 heures. Si vous ne recevez pas l\'email, vérifiez votre dossier spam.'
        },
        {
          question: 'Comment modifier mes informations personnelles ?',
          answer: 'Connectez-vous à votre compte, accédez à votre profil en cliquant sur votre photo en haut à droite, puis sélectionnez "Paramètres du compte". Vous pourrez modifier toutes vos informations personnelles et professionnelles.'
        },
        {
          question: 'Puis-je avoir plusieurs comptes ?',
          answer: 'Non, chaque utilisateur ne peut avoir qu\'un seul compte par adresse email. Cependant, vous pouvez basculer entre un profil candidat et entreprise si nécessaire en contactant notre support.'
        }
      ]
    },
    {
      id: '1',
      category: 'Appels d\'offres',
      icon: 'fa-briefcase',
      questions: [
        {
          question: 'Comment publier un Appel d\'offres ?',
          answer: 'Une fois connecté en tant qu\'entreprise, accédez à votre tableau de bord et cliquez sur "Publier une offre". Remplissez tous les détails du poste (titre, description, compétences requises, salaire, localisation, etc.) et publiez votre annonce. Votre offre sera visible immédiatement après validation.'
        },
        {
          question: 'Combien de temps reste une offre en ligne ?',
          answer: 'Les Appels d\'offres restent actifs pendant 30 jours par défaut. Vous pouvez prolonger la durée de publication ou clôturer l\'offre à tout moment depuis votre tableau de bord. Les offres expirées peuvent être réactivées facilement.'
        },
        {
          question: 'Comment modifier ou supprimer une offre ?',
          answer: 'Accédez à votre tableau de bord, section "Mes offres". Cliquez sur l\'offre que vous souhaitez modifier, puis utilisez les boutons "Modifier" ou "Supprimer". Les modifications sont appliquées immédiatement.'
        },
        {
          question: 'Puis-je promouvoir mon Appel d\'offres ?',
          answer: 'Oui, nous proposons plusieurs options de promotion pour augmenter la visibilité de vos offres : mise en avant sur la page d\'accueil, envoi dans notre newsletter, et partage sur nos réseaux sociaux. Consultez nos forfaits premium pour plus de détails.'
        }
      ]
    },
    {
      id: '2',
      category: 'Candidatures',
      icon: 'fa-file-alt',
      questions: [
        {
          question: 'Comment postuler à une offre ?',
          answer: 'Parcourez les Appels d\'offres disponibles, cliquez sur celui qui vous intéresse, puis cliquez sur "Postuler". Assurez-vous que votre CV et votre profil sont à jour avant de soumettre votre candidature. Vous pouvez ajouter une lettre de motivation personnalisée.'
        },
        {
          question: 'Puis-je suivre l\'état de mes candidatures ?',
          answer: 'Oui, dans votre tableau de bord, section "Mes candidatures", vous pouvez voir toutes vos candidatures avec leur statut : en attente, vue, acceptée, ou refusée. Vous recevrez également des notifications par email à chaque changement de statut.'
        },
        {
          question: 'Comment retirer une candidature ?',
          answer: 'Accédez à "Mes candidatures" dans votre tableau de bord, trouvez la candidature concernée et cliquez sur "Retirer la candidature". Cette action est irréversible, mais vous pourrez postuler à nouveau si l\'offre est toujours active.'
        },
        {
          question: 'Combien de candidatures puis-je envoyer ?',
          answer: 'Il n\'y a pas de limite au nombre de candidatures que vous pouvez envoyer. Cependant, nous vous recommandons de personnaliser chaque candidature pour maximiser vos chances de succès.'
        }
      ]
    },
    {
      id: '3',
      category: 'Tarifs et Abonnements',
      icon: 'fa-credit-card',
      questions: [
        {
          question: 'Quels sont les tarifs de SenOffre ?',
          answer: 'SenOffre propose plusieurs formules : Gratuit pour les candidats (inscription et candidatures illimitées), Basique pour les entreprises (5 offres/mois), Premium (20 offres/mois + fonctionnalités avancées), et Entreprise (offres illimitées + support prioritaire). Consultez notre page "Tarifs" pour les détails.'
        },
        {
          question: 'Comment puis-je payer mon abonnement ?',
          answer: 'Nous acceptons les paiements par carte bancaire (Visa, Mastercard), Mobile Money (Orange Money, Wave, Free Money), et virement bancaire. Tous les paiements sont sécurisés et cryptés.'
        },
        {
          question: 'Puis-je annuler mon abonnement ?',
          answer: 'Oui, vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre compte. L\'annulation prendra effet à la fin de votre période de facturation en cours. Aucun remboursement n\'est effectué pour la période déjà payée.'
        },
        {
          question: 'Y a-t-il une période d\'essai ?',
          answer: 'Oui, nous offrons une période d\'essai gratuite de 14 jours pour tous nos forfaits premium. Aucune carte bancaire n\'est requise pour démarrer l\'essai. Vous pouvez annuler à tout moment pendant la période d\'essai.'
        }
      ]
    },
    {
      id: '4',
      category: 'Support et Assistance',
      icon: 'fa-headset',
      questions: [
        {
          question: 'Comment contacter le support technique ?',
          answer: 'Vous pouvez nous contacter par email à support@senoffre.com, par téléphone au +221 33 123 45 67, via le chat en direct sur notre site, ou via le formulaire de contact. Notre équipe répond généralement dans les 24 heures.'
        },
        {
          question: 'Quels sont les horaires du support ?',
          answer: 'Notre support est disponible du lundi au vendredi de 8h à 18h (GMT), et le samedi de 9h à 13h (GMT). Le chat en direct est disponible pendant ces horaires. Les emails sont traités 7j/7.'
        },
        {
          question: 'Où puis-je trouver des tutoriels ?',
          answer: 'Nous avons une section complète de tutoriels vidéo et de documentation accessible depuis votre tableau de bord. Vous y trouverez des guides pas à pas pour toutes les fonctionnalités de la plateforme.'
        },
        {
          question: 'Comment signaler un problème ou un bug ?',
          answer: 'Utilisez le formulaire de contact en sélectionnant "Signaler un bug" comme sujet. Décrivez le problème en détail avec des captures d\'écran si possible. Notre équipe technique traitera votre signalement en priorité.'
        }
      ]
    },
    {
      id: '5',
      category: 'Sécurité et Confidentialité',
      icon: 'fa-shield-alt',
      questions: [
        {
          question: 'Mes données sont-elles sécurisées ?',
          answer: 'Oui, nous utilisons les derniers standards de sécurité (cryptage SSL, authentification à deux facteurs, etc.) pour protéger vos données. Toutes les informations sensibles sont cryptées et stockées de manière sécurisée.'
        },
        {
          question: 'Qui peut voir mon profil et mon CV ?',
          answer: 'Seules les entreprises avec un compte vérifié peuvent voir votre profil complet. Vous pouvez également rendre votre profil privé dans les paramètres. Vos coordonnées ne sont jamais partagées sans votre consentement.'
        },
        {
          question: 'Comment supprimer mon compte définitivement ?',
          answer: 'Accédez aux paramètres de votre compte, section "Confidentialité et sécurité", puis cliquez sur "Supprimer mon compte". Cette action est irréversible et toutes vos données seront supprimées dans les 30 jours.'
        },
        {
          question: 'Utilisez-vous mes données à des fins commerciales ?',
          answer: 'Non, nous ne vendons jamais vos données personnelles. Nous les utilisons uniquement pour améliorer nos services et vous proposer des offres pertinentes. Consultez notre politique de confidentialité pour plus de détails.'
        }
      ]
    }
  ];

  const filteredFAQ = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(
      q => q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
           q.answer.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);

  return (
    <div className="admin-faq-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <h2 className="page-title">
              <i className="fa fa-question-circle me-3"></i>
              Questions Fréquentes (FAQ)
            </h2>
            <p className="page-subtitle">
              Trouvez rapidement des réponses à vos questions
            </p>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <Card className="search-card mb-4">
        <Card.Body>
          <Form.Group>
            <div className="search-wrapper">
              <i className="fa fa-search search-icon"></i>
              <Form.Control
                type="text"
                placeholder="Rechercher une question..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
            </div>
          </Form.Group>
        </Card.Body>
      </Card>

      {/* FAQ Categories Stats */}
      <Row className="mb-4">
        {faqData.slice(0, 4).map((category, index) => (
          <Col xl={3} lg={6} sm={6} key={index}>
            <Card className="category-stat-card">
              <Card.Body>
                <div className="category-icon">
                  <i className={`fa ${category.icon}`}></i>
                </div>
                <div className="category-content">
                  <h4 className="category-title">{category.category}</h4>
                  <p className="category-count">{category.questions.length} questions</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* FAQ Accordion */}
      <Card className="faq-content-card">
        <Card.Body>
          {filteredFAQ.length === 0 ? (
            <div className="no-results">
              <i className="fa fa-search fa-3x mb-3"></i>
              <h4>Aucun résultat trouvé</h4>
              <p>Essayez avec d'autres mots-clés ou parcourez toutes les catégories</p>
            </div>
          ) : (
            filteredFAQ.map((category) => (
              <div key={category.id} className="faq-category-section">
                <div className="category-header">
                  <i className={`fa ${category.icon} me-3`}></i>
                  <h3>{category.category}</h3>
                </div>
                
                <Accordion defaultActiveKey={activeKey} className="faq-accordion">
                  {category.questions.map((item, index) => (
                    <Accordion.Item 
                      eventKey={`${category.id}-${index}`} 
                      key={index}
                      className="faq-accordion-item"
                    >
                      <Accordion.Header className="faq-accordion-header">
                        <div className="question-wrapper">
                          <i className="fa fa-question-circle me-3"></i>
                          <span>{item.question}</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="faq-accordion-body">
                        <p>{item.answer}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            ))
          )}
        </Card.Body>
      </Card>

      {/* Contact Support Section */}
      <Card className="support-cta-card mt-4">
        <Card.Body>
          <Row className="align-items-center">
            <Col lg={8}>
              <div className="support-cta-content">
                <h3>Vous ne trouvez pas la réponse à votre question ?</h3>
                <p>Notre équipe de support est là pour vous aider. Contactez-nous et nous vous répondrons dans les plus brefs délais.</p>
              </div>
            </Col>
            <Col lg={4} className="text-lg-end text-center mt-3 mt-lg-0">
              <Button href="/admin/page-contact" className="btn-contact-support">
                <i className="fa fa-envelope me-2"></i>
                Contacter le Support
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FAQ;
